import { Color, colors, getFontStyle, FontWeight } from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import { FC } from 'react';

export const labelHeight = '20px';

interface CustomStyles {
  weight?: FontWeight;
}

interface LabelProps extends CustomStyles {
  size?: string;
  label?: string;
  color?: Color | undefined;
  testID?: string;
  htmlFor?: string | undefined;
  id?: string;
  children?: React.ReactNode;
}

export const LabelWrapper = styled.label<CustomStyles>`
  ${getFontStyle('s', 'bold')};
  display: flex;
  color: ${colors.gray1};
  align-items: center;
  width: 100%;
  min-height: ${labelHeight};
  margin-bottom: 5px;
`;

export const Label: FC<LabelProps> = ({
  label,
  color = undefined,
  weight = 'semi',
  htmlFor = '',
  id = '',
  testID = '',
  children,
}) => {
  return (
    <LabelWrapper
      htmlFor={htmlFor}
      id={id}
      weight={weight}
      data-testid={testID}
      color={color}
      aria-label={label}
    >
      {children}
    </LabelWrapper>
  );
};
